import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Arrow } from '../../../../icons/index';
import { sharpSansSemibold, sharpSansMedium } from '../../../../typography';
import { navy, grey, grey25 } from '@zocdoc/branding/colors';

const Header = styled.div`
    ${sharpSansSemibold(15, 24)}
    color: ${navy};
`;

const Text = styled.div`
    ${sharpSansMedium(15, 20)}
    color: ${grey};
`;

const ArrowWrapper = styled.div`
    float: right;
    padding: 10px 12px;
`;

const ResultSectionWrapper = styled.div`
    padding: 8px 16px;
    width: 100%;
    min-width: 320px;
`;
const ResultSection = styled.div`
    border-bottom: solid 1px ${grey25};
    padding: 10px 0px;
`;

const SmallArrow = styled(Arrow)`
    height: 12px;
`;

const getSection = ({
    headerText, selectedText, dataProdGuids, dataTest, onClick,
}) => {
    return (
        <ResultSection>
            <ArrowWrapper onClick={onClick}>
                <SmallArrow
                    color={navy}
                    direction={Arrow.direction.right}
                />
            </ArrowWrapper>
            <Header> {headerText} </Header>
            <Text
                data-prod-guids={dataProdGuids}
                data-test={dataTest}
                onClick={onClick}
            > {selectedText}
            </Text>
        </ResultSection>
    );
};

export default class ScanCardResultsView extends Component {
    componentDidMount() {
        this.props.selectFirstCarrierAndPlan();
    }

    render() {
        const {
            carrier,
            plan,
            editCarrier,
            editPlan,
        } = this.props;

        if (!carrier) {
            return null;
        }

        return (
            <div>
                <ResultSectionWrapper>
                    {getSection({
                        selectedText: carrier.carrier_name,
                        onClick: editCarrier,
                        dataProdGuids: `carrier-${carrier.carrier_id}:[003703d2]`,
                        dataTest: `carrier-${carrier.carrier_id}`,
                        headerText: (
                            <FormattedMessage
                                defaultMessage="Verify carrier name"
                                id="InsurancePicker.ScanCard.Results.CarrierHeader"
                            />),
                    })}

                    {getSection({
                        selectedText: plan.plan_name,
                        onClick: editPlan,
                        dataProdGuids: `plan-${carrier.carrier_id}:[003703d2]`,
                        dataTest: `plan-${plan.plan_id}`,
                        headerText: (
                            <FormattedMessage
                                defaultMessage="Verify plan name"
                                id="InsurancePicker.ScanCard.Results.PlanHeader"
                            />),
                    })}
                </ResultSectionWrapper>
            </div>
        );
    }
}
